export default "__VITE_ASSET__E_Ogrxab__"